// extracted by mini-css-extract-plugin
module.exports = {"button":"zoom-button_button__3G1Xv","_success":"zoom-button__success__3M8XJ","spinner":"zoom-button_spinner__1gE6_"};